import React from 'react';

import UserReviewStarsIcon from '@core/assets/icons/user-review-stars.svg';

import classes from './UserReviewStars.module.scss';

const UserReviewStars = () => {
    return (
        <div className={classes['wrapper']}>
            <div className='d-flex justify-content-center align-items-center gap-2'>
                <span>4.7</span>
                <UserReviewStarsIcon />
            </div>
            <p>User Review Stars</p>
        </div>
    );
};

export default UserReviewStars;